import api from "./Api";
import NFeListingApi from "./NFeListingApi";
import NFCeListingApi from "./NFCeListingApi";
import CTeListingApi from "./CTeListingApi";
import MDFeListingApi from "./MDFeListingApi";
import { CockpitDocument } from "model/cockpit/CockpitDocument";
import { NFe } from "model/NFe";

const nfeApi = new NFeListingApi();

/* os métodos de download da NFe só leem o id; o tipo NFe exige issuerCnpj e company, que eles não usam */
const asNFe = (doc: CockpitDocument) => ({ id: doc.id } as NFe);
const nfceApi = new NFCeListingApi();
const cteApi = new CTeListingApi();
const mdfeApi = new MDFeListingApi();

/* só a busca é do cockpit: histórico, XML e PDF vão para os endpoints da listagem de cada tipo */
export default class CockpitApi {

    /* um dos dois: transactionId ou accessKey */
    fetchDocuments = (search: { transactionId?: string, accessKey?: string }, companyId: number | null): Promise<CockpitDocument[]> => {
        return api.get('/cockpit/documents', { params: { ...search, companyId } }).then(({ data }) => data);
    }

    fetchHistory = (doc: CockpitDocument): Promise<any> => {
        switch (doc.type) {
            case 'NFE': return nfeApi.fetchNFeHistory(doc.id);
            case 'NFCE': return nfceApi.fetchNFCeHistory(doc.id);
            case 'CTE': return cteApi.fetchCTeHistory(doc.id);
            case 'MDFE': return mdfeApi.fetchMDFeHistory(doc.id);
        }
    }

    downloadXml = (doc: CockpitDocument) => {
        switch (doc.type) {
            case 'NFE': return nfeApi.downloadXml(asNFe(doc));
            case 'NFCE': return nfceApi.downloadXml({ id: doc.id });
            case 'CTE': return cteApi.downloadXml({ id: doc.id });
            case 'MDFE': return mdfeApi.downloadXml({ id: doc.id });
        }
    }

    downloadPdf = (doc: CockpitDocument) => {
        switch (doc.type) {
            case 'NFE': return nfeApi.downloadDanfe(asNFe(doc));
            case 'NFCE': return nfceApi.downloadDanfce({ id: doc.id });
            case 'CTE': return cteApi.downloadDacte({ id: doc.id });
            case 'MDFE': return mdfeApi.downloadDamdfe({ id: doc.id });
        }
    }
}
